import { FC, memo, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';

import { DateTimePickerRangeProps } from './types';

// Use type assertion to fix TypeScript compatibility issues with react-flatpickr 4.0.1
const FlatpickrComponent = Flatpickr as any;

const Component: FC<DateTimePickerRangeProps> = memo((props) => {
    const { disabled = false, enableTime = true, name, options, value, defaultValue, required = false, onChange, ...restProps } = props;
    options && (options.mode = 'range');
    options && (options.plugins = [rangePlugin({ input: `#${name}endDate` })]);
    const [startDate, setStartDate] = useState<Date[]>([]);
    const [endDate, setEndDate] = useState<Date[]>([]);
    const handleStartDateChange = (value: Date[]) => {
        setStartDate(value);
        onChange({ startDate: value, endDate: endDate });
    };

    const handleEndDateChange = (value: Date[]) => {
        setEndDate(value);
        onChange({ startDate: startDate, endDate: value });
    };
    return (
        <>
            <FlatpickrComponent
                className="form-control"
                name={`${name}.startDate`}
                id={`${name}.startDate`}
                autoComplete={'off'}
                data-enable-time={enableTime}
                onChange={(value: Date[]) => handleStartDateChange(value)}
                disabled={disabled}
                {...restProps}
            />

            <span className="input-group-text">to</span>

            <FlatpickrComponent
                className="form-control"
                value={value ? value['endDate'] : defaultValue}
                name={`${name}.endDate`}
                id={`${name}.endDate`}
                autoComplete={'off'}
                data-enable-time={enableTime}
                onChange={(value: Date[]) => handleEndDateChange(value)}
                required={required}
                disabled={disabled}
            />
        </>
    );
});
Component.displayName = 'DateTimePickerRange';

export const DateTimePickerRange: FC<DateTimePickerRangeProps> = Object.assign(Component, {});
